import { Observable } from 'rxjs';
import { HdWizardStepTracker } from './step-tracker';

export interface HdWizardStepMeta {
  path: string;
  component?: any;
  resolveComponent?: () => any;
  isFinal?: boolean;
  resolve?: ResolveStepData;
  params?: HdWizardStepParam;
  nextStep?: string;
  getNextStep?: (
    tracker: HdWizardStepTracker,
    self: HdWizardStepMeta,
    currentSkipped: boolean
  ) => string | Observable<string> | Promise<string>;
}

export interface ResolveStepData {
  [name: string]: WizardStepResolve<any> | any;
}

export interface WizardStepResolve<T> {
  resolve(tracker?: HdWizardStepTracker, params?: HdWizardStepParam): Observable<T> | Promise<T> | T;
}

export interface HdWizardStepTrackerStep {
  data?: any;
  path: string;
  next?: string;
  params?: HdWizardStepParam;
  title?: string;
  dirty?: boolean;
  complete?: boolean;
}

export interface HdWizardStepTrackerSnapshot { [name: string]: any; }
export interface HdWizardStepParam { [name: string]: any; }

export interface HdWizardStepTree {
  id: string;
  title: string;
  for: string;
  children: HdWizardStepTree[];
}

export interface HdWizardProgress {
  currentStepGroup: number;
  totalStepGroups: number;
  currentStep: number;
  totalSteps: number;
}

export interface HdWizardStepTreeSnapshot {
  segment: string;
  children: HdWizardStepTreeSnapshot[];
  complete?: boolean;
  active?: boolean;
}

export interface HdWizardStorage {
  getStoredData(key: string): { data: any; steps: HdWizardStepTrackerStep[]; version: WizardVersion };
  store(key: string, data: { steps: HdWizardStepTrackerStep[], data: any, version: WizardVersion }): void;
}

export interface HdWizardOptions {
  trackingOptions?: HdWizardStepTrackerOptions;
}

export interface HdWizardStepTrackerOptions {
  storageKey?: string;
  trackingStrategy?: HdWizardStepTrackingStrategy;
}

export enum HdWizardStepTrackingStrategy {
  DISCARD_ALWAYS,
  DISCARD_ON_DIRTY
}

export enum HdWizardState {
  INIT,
  IDLE,
  LOADING_STEP,
  ERRORED
}

export interface HdWizardStateWrapper {
  state: HdWizardState;
  error?: any;
}


export interface HdWizardTimeTravelData {
  steps: HdWizardStepTrackerStep[];
  data?: any;
  skipUpdateQueryParams?: boolean;
  next?: boolean;
}

export enum WizardVersion {
  V2 = 'V2'
}
